angular.module('FlexyBeautyApp.services').factory('SaleAdvance_Resource', [
    "$resource", "$location",
    function ($resource,$location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/sale-advances', {}, {
            retrieveAll: {method: 'GET', isArray: true},
        });
    }
]);

angular.module('FlexyBeautyApp.services').
factory('SaleAdvance', ["Payment", "Site", "CustomerData", "HumanResourceData", "DayData",
    "SaleService", "SaleProduct", "SaleCure", "GiftItem", "LoyaltyCardItem", "LoyaltyCardItemData",
    function (Payment, Site, CustomerData, HumanResourceData, DayData, SaleService, SaleProduct, SaleCure,
              GiftItem, LoyaltyCardItem, LoyaltyCardItemData) {
        let SaleAdvance = function (saleAdvanceRes) {
            this.id = null;
            this.status = "advance";
            this.timeCreated = null;
            this.timeModified = null;
            this.customerId = null;
            this.customer = null;
            this.dayId = null;
            this.day = null;
            this.estimationNumber = null;
            this.advanceNumber = null;
            this.hrSellerId = null;
            this.hrSeller = null;
            this.hrOp = null;
            this.hrOpId = null;
            this.site = null;
            this.siteV = null;
            this.softV = null;
            this.signature = null;
            this.pSignature = null;
            this.signatureCode = null;
            this.dsignatureCode = null;
            this.vat = null;
            this.vatCode = null;
            this.servicesPrice = null;
            this.productsPrice = null;
            this.curesPrice = null;
            this.giftItemsPrice = null;
            this.loyaltyCardsPrice = null;
            this.price = null;
            this.priceHT = null;
            this.priceTurnover = null;
            this.priceTurnoverHT = null;
            this.vatPrice = null;
            this.oExt = null;
            this.discountPercent = null;
            this.isCreatedByCustomer = false;
            this.nbPrint = null;
            this.loyaltyCardItemId = null;
            this.loyaltyCardItem = null;
            this.loyaltyPts = null;
            this.totalLoyaltyPts = null;
            this.hasLoyaltyDiscount = null;
            this.loyaltyDate = null;
            this.companyName = null;
            this.payments = [];
            this.saleServices = [];
            this.saleProducts = [];
            this.saleCures = [];
            this.giftItems = [];
            this.loyaltyCardItems = [];
            this.advancePrice = 0;
            this.realPaidPrice = 0;
            this.customerLastname = null;
            this.customerFirstname = null;
            this.customerAddress = null;
            this.customerZip = null;
            this.customerCity = null;
            this.shareCapital = null;
            this.greffeCity = null;
            this.juridicForm = null;

            if (saleAdvanceRes !== undefined && saleAdvanceRes != null) {
                this.loadObjectProperties(saleAdvanceRes);
                this.loadObjectSaleServices(saleAdvanceRes);
                this.loadObjectSaleProducts(saleAdvanceRes);
                this.loadObjectSaleCures(saleAdvanceRes);
                this.loadObjectGiftItems(saleAdvanceRes);
                this.loadObjectLoyaltyCardItems(saleAdvanceRes);
            }
        };

        SaleAdvance.prototype.loadObjectProperties = function(saleAdvanceRes) {
            if (saleAdvanceRes) {
                this.id = saleAdvanceRes.id;
                this.timeCreated = saleAdvanceRes.timeCreated;
                this.timeModified = saleAdvanceRes.timeModified;
                this.customerId = saleAdvanceRes.customerId;
                if (saleAdvanceRes.customerId !== undefined) {
                    this.customer = CustomerData.getById(this.customerId);
                }
                this.dayId = saleAdvanceRes.dayId;
                if (saleAdvanceRes.dayId !== undefined) {
                    this.day = DayData.getById(this.dayId);
                }
                this.estimationNumber = saleAdvanceRes.estimationNumber;
                this.advanceNumber = saleAdvanceRes.advanceNumber;
                this.hrSellerId = saleAdvanceRes.hrSellerId;
                if (saleAdvanceRes.hrSellerId !== undefined) {
                    this.hrSeller = HumanResourceData.getById(saleAdvanceRes.hrSellerId);
                }
                if (saleAdvanceRes.hrOpId !== undefined) {
                    this.hrOp = HumanResourceData.getById(saleAdvanceRes.hrOpId);
                }
                if (saleAdvanceRes.site) {
                    this.site = new Site(saleAdvanceRes.site);
                }
                this.siteV = saleAdvanceRes.siteV;
                this.softV = saleAdvanceRes.softV;
                this.signature = saleAdvanceRes.signature;
                this.pSignature = saleAdvanceRes.pSignature;
                this.signatureCode = saleAdvanceRes.signatureCode;
                this.dsignatureCode = saleAdvanceRes.dsignatureCode;
                this.vat = saleAdvanceRes.vat;
                this.vatCode = saleAdvanceRes.vatCode;
                this.servicesPrice = saleAdvanceRes.servicesPrice;
                this.productsPrice = saleAdvanceRes.productsPrice;
                this.curesPrice = saleAdvanceRes.curesPrice;
                this.giftItemsPrice = saleAdvanceRes.giftItemsPrice;
                this.loyaltyCardsPrice = saleAdvanceRes.loyaltyCardsPrice;
                this.price = saleAdvanceRes.price;
                this.priceHT = saleAdvanceRes.priceHT;
                this.priceTurnover = saleAdvanceRes.priceTurnover;
                this.priceTurnoverHT = saleAdvanceRes.priceTurnoverHT;
                this.vatPrice = saleAdvanceRes.vatPrice;
                this.advancePrice = saleAdvanceRes.advancePrice;
                this.oExt = saleAdvanceRes.oExt;
                this.discountPercent = saleAdvanceRes.discountPercent;
                this.isCreatedByCustomer = saleAdvanceRes.isCreatedByCustomer;
                this.nbPrint = saleAdvanceRes.nbPrint;
                this.loyaltyCardItemId = saleAdvanceRes.loyaltyCardItemId;
                if (saleAdvanceRes.loyaltyCardItemId !== undefined) {
                    this.loyaltyCardItem = LoyaltyCardItemData.getById(saleAdvanceRes.loyaltyCardItemId);
                }
                this.loyaltyPts = saleAdvanceRes.loyaltyPts;
                this.totalLoyaltyPts = saleAdvanceRes.totalLoyaltyPts;
                this.hasLoyaltyDiscount = saleAdvanceRes.hasLoyaltyDiscount;
                this.loyaltyDate = saleAdvanceRes.loyaltyDate;
                this.companyName = saleAdvanceRes.companyName;
                this.payments = [];
                if (saleAdvanceRes.payments) {
                    for (let i = 0; i < saleAdvanceRes.payments.length; i++) {
                        this.payments.push(new Payment(saleAdvanceRes.payments[i]));
                    }
                }
                for (let i = 0; i < this.payments.length; i++) {
                    if (this.payments[i].type !== "UNPAID" && this.payments[i].type !== "GIFT") {
                        this.realPaidPrice += this.payments[i].price;
                    }
                }
                this.customerLastname = saleAdvanceRes.customerLastname;
                this.customerFirstname = saleAdvanceRes.customerFirstname;
                this.customerAddress = saleAdvanceRes.customerAddress;
                this.customerZip = saleAdvanceRes.customerZip;
                this.customerCity = saleAdvanceRes.customerCity;
                this.shareCapital = saleAdvanceRes.shareCapital;
                this.greffeCity = saleAdvanceRes.greffeCity;
                this.juridicForm = saleAdvanceRes.juridicForm;
            }
        };

        SaleAdvance.prototype.loadObjectSaleServices = function (object) {
            if (object.saleServices) {
                this.saleServices = [];
                for (let oneSaleService of object.saleServices) {
                    if (!oneSaleService.saleId || oneSaleService.saleId === this.id) {
                        let saleService = new SaleService(oneSaleService, true);
                        saleService.sale = this;
                        this.saleServices.push(saleService);
                    }
                }
            }
        };

        SaleAdvance.prototype.loadObjectSaleProducts = function (object) {
            if (object.saleProducts) {
                this.saleProducts = [];
                for (let oneSaleProduct of object.saleProducts) {
                    if (!oneSaleProduct.saleId || oneSaleProduct.saleId === this.id) {
                        let saleProduct = new SaleProduct(oneSaleProduct, true);
                        saleProduct.sale = this;
                        this.saleProducts.push(saleProduct);
                    }
                }
            }
        };

        SaleAdvance.prototype.loadObjectSaleCures = function (object) {
            if (object.saleCures) {
                this.saleCures = [];
                for (let oneSaleCure of object.saleCures) {
                    if (!oneSaleCure.saleId || oneSaleCure.saleId === this.id) {
                        let saleCure = new SaleCure(oneSaleCure, true);
                        saleCure.sale = this;
                        this.saleCures.push(saleCure);
                    }
                }
            }
        };

        SaleAdvance.prototype.loadObjectGiftItems = function (object) {
            if (object.giftItems) {
                this.giftItems = [];
                for (let oneGiftItem of object.giftItems) {
                    if (!oneGiftItem.saleId || oneGiftItem.saleId === this.id) {
                        let giftItem = new GiftItem(oneGiftItem, true);
                        giftItem.loadRef(true);
                        giftItem.sale = this;
                        this.giftItems.push(giftItem);
                    }
                }
            }
        };

        SaleAdvance.prototype.loadObjectLoyaltyCardItems = function(object) {
            if (object.loyaltyCardItems) {
                this.loyaltyCardItems = [];
                for (let oneLoyaltyCardItem of object.loyaltyCardItems) {
                    if (!oneLoyaltyCardItem.saleId || oneLoyaltyCardItem.saleId === this.id) {
                        let loyaltyCardItem = new LoyaltyCardItem(oneLoyaltyCardItem, true);
                        loyaltyCardItem.sale = this;
                        this.loyaltyCardItems.push(loyaltyCardItem);
                    }
                }
            }
        };

        SaleAdvance.prototype.getAllItemsPrice = function(){
            let allItemPrice = 0;
            for (let i = 0; i < this.saleServices.length; i++) {
                allItemPrice += this.saleServices[i].price;
            }
            for (let i = 0; i < this.saleProducts.length; i++) {
                allItemPrice += this.saleProducts[i].price;
            }
            for (let i = 0; i < this.saleCures.length; i++) {
                allItemPrice += this.saleCures[i].price;
            }
            for (let i = 0; i < this.giftItems.length; i++) {
                allItemPrice += this.giftItems[i].price;
            }
            for (let i = 0; i < this.loyaltyCardItems.length; i++) {
                allItemPrice += this.loyaltyCardItems[i].price;
            }
            return allItemPrice;
        };

        return SaleAdvance;
    }]);

angular.module('FlexyBeautyApp.services').factory('SaleAdvanceSrv', ['SaleAdvance_Resource',
    function (SaleAdvance_Resource) {
        let saleAdvanceSrv = {};

        saleAdvanceSrv.retrieveAll = function () {
            return SaleAdvance_Resource.retrieveAll().$promise;
        }

        return saleAdvanceSrv;
    }
]);




// WEBPACK FOOTER //
// ./js/services/models/SaleAdvance.js